
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Wounds(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Wounds"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>A wound is a <b>type of injury</b> which happens relatively quickly in which skin
                                    is torn, cut, or punctured (an open wound), or where blunt force trauma
                                    causes a contusion (a closed wound). In pathology, it specifically refers to
                                    a sharp injury which damages the epidermis of the skin.</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Wounds/1.png")} alt="Wounds" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Types of wounds: </b></p>
                                <p><b>Penetrating wounds</b></p>
                                <p>Puncture wounds</p>
                                <p>Surgical wounds and incisions</p>
                                <p>Thermal, chemical or electric burns</p>
                                <p>Bites and stings</p>
                                <p>Gunshot wounds, or other high velocity projectiles that can penetrate the body</p>
                                <p><b>Blunt force trauma</b></p>
                                <p>Abrasions</p>
                                <p>Lacerations</p>
                                <p>Skin tears</p>
                                <p><b>Major types of closed wounds include:</b></p>
                                <p><b>Contusions – </b>blunt trauma causing pressure damage to the skin and/or underlying tissues</p>
                                <p><b>Seroma – </b>a fluid-filled area that develops under the skin or tissue</p>
                                <p><b>Hematoma – </b>a blood-filled area that develops under the skin or tissue (occurring when there is
                                    internal blood vessel damage to an artery or vein)</p>
                                <p>Crush injuries</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Wound">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Wounds;